import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Application-wide loading screen that appears during authentication
 * and other major loading operations
 *
 * @param {Object} props - Component props
 * @param {string} [props.message="Loading..."] - Message to display during loading
 * @returns {JSX.Element} Full-screen loading indicator
 */
const LoadingScreen = ({ message = "Loading..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 3, fontWeight: "medium", opacity: 0.8 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
